var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<li class=\"sda-seo-meta-keyword\" data-keyword=\""
    + alias2(alias1(depth0, depth0))
    + "\">\n    "
    + alias2(alias1(depth0, depth0))
    + "\n    <i class=\"fa-times\"></i>\n</li>\n";
},"useData":true});